module.exports = __webpack_public_path__ + "img/horizontal_2_1_2.08620cae.png";